import { ReactElement } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Dialog, Link } from '@material-ui/core';

import { withPageImpression } from '@spotify/plugin-confidence-tracking-react';

import { Branding } from '../SignUp/Branding';
import { TransitionScreen } from '../TransitionScreen';
import { XirpEmailVerifiedPage } from './Xirp';

const XIRP_APP_NAME = 'xirp';

/**
 * Landing page after clicking email verification link.
 *
 * This is a simple confirmation page that tells the user their email
 * has been verified and they can close this tab. The original signup
 * tab should still be open - they can click "I've verified my email"
 * there to continue.
 */
const EmailVerifiedPageComponent = () => {
  return (
    <Dialog open fullScreen>
      <Branding />
      <TransitionScreen
        title="Email verified!"
        description="Your email has been verified. You can close this tab and return to the signup window."
        helperText={
          <>
            Closed your signup window?{' '}
            <Link href="/signup" underline="always">
              Continue here
            </Link>
          </>
        }
      />
    </Dialog>
  );
};

export const EmailVerifiedPage = withPageImpression(
  EmailVerifiedPageComponent,
  { pageId: 'email-verified' },
);

export const EmailVerifiedRoute = (): ReactElement => {
  const [searchParams] = useSearchParams();
  const appParam = searchParams.get('app');

  if (appParam?.toLowerCase() === XIRP_APP_NAME) {
    return <XirpEmailVerifiedPage />;
  }

  return <EmailVerifiedPage />;
};
